import { createFileRoute } from '@tanstack/react-router';
import { SignUp } from '@clerk/react';
import { ClerkScope } from '../auth/ClerkScope';
import { AuthLayout } from '../pages/auth/AuthLayout';
import { authFormAppearance } from '../pages/auth/authFormAppearance';
import { m } from '../paraglide/messages';

/** The destination of every "Get Started" on the marketing site. See `/sign-in`. */
export const Route = createFileRoute('/sign-up')({
  ssr: false,
  // Its own title for the reason `/sign-in` gives.
  head: () => ({ meta: [{ title: m.app_sign_up_title() }] }),
  component: SignUpRoute,
});

function SignUpRoute() {
  return (
    <ClerkScope>
      <AuthLayout title={m.app_sign_up_heading()}>
        <SignUp appearance={authFormAppearance} />
      </AuthLayout>
    </ClerkScope>
  );
}
